export class SecurityTypeResult {
  securityTypeId!: number;
  name!: string;
  taxResultItemTypeResults!: TaxResultItemTypeResult[];
}

export class TaxResultItemTypeResult {
  name!: string;
  taxResultItemTypeId!: number;
}
